import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatLineBreaks',
})
export class FormatLineBreaksPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) return '';
    return value.replace(/\\n/g, '\n');
  }
}
